import React from "react";
import styled from "styled-components";

export default function LegendInput({
  label,
  type = "text",
  placeholder = "",
  required = true,
  value,
  setValue,
  pattern = undefined,
}) {
  return (
    <div style={{ width: "100%" }}>
      <div
        className="h4"
        style={{ opacity: "0", maxWidth: "95%", marginBottom: "0" }}
      >
        {label}
      </div>
      <Container>
        <label
          className="h4"
          htmlFor={label
            .split(" ")
            .map((el, ind) =>
              ind === 0 ? el?.[0].toLowerCase() : el?.[0].toUpperCase()
            )
            .join("")}
        >
          {label}
        </label>
        <input
          type={type}
          name={label
            .split(" ")
            .map((el, ind) =>
              ind === 0 ? el?.[0].toLowerCase() : el?.[0].toUpperCase()
            )
            .join("")}
          id={label
            .split(" ")
            .map((el, ind) =>
              ind === 0 ? el?.[0].toLowerCase() : el?.[0].toUpperCase()
            )
            .join("")}
          required={required}
          placeholder={placeholder}
          className={``}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          pattern={pattern}
        />
      </Container>
    </div>
  );
}

const Container = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid #a6a4a1;
  border-radius: 8px;
  & > label {
    position: absolute;
    max-width: 95%;
    left: 1rem;
    top: 0;
    text-align: left;
    transform: translateY(-80%);
    background-color: var(--aj-white, #ffffff);
    padding: 0 0.5rem;
    font-size: 1rem;
  }
  & > input {
    width: 100%;
    padding: 16px;
    border-radius: 8px;
    border: none;
    outline: none;
    color: #000;
    &:invalid,
    & > .error {
      color: #da1f26;
    }
  }
`;
